(function () {
    var tables = document.querySelectorAll('.text table');
    Array.from(tables).forEach(table => {
        var container = document.createElement('div');
        container.classList.add('table-container');
        if (table.classList.contains('wide')) {
            container.classList.add('table-container--wide');
        }
        wrap(table, container);
    })

    function wrap(node, wrapper) {
        var parent = node.parentNode;
        var previousSibling = node.previousSibling;
        wrapper.appendChild(node);

        parent.insertBefore(wrapper, previousSibling);
        return wrapper;
    }
})(document);